const leatherColorObjs = [
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'レッドオレンジ', value: 'redOrange', color: '#FF362E' },
  { label: 'ばなな', value: 'banana', color: '#E8C84B' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#D9D943' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'むきばなな', value: 'brown', color: '#D7CEA5' },
  { label: 'ブルー', value: 'blue', color: '#0d42b5' },
  { label: 'ベイラーブルー', value: 'valorBlue', color: '#61BCBA' },
  { label: '早熟ばなな', value: 'mardiGras', color: '#4e734c' },
  { label: 'ティール', value: 'tealGreen', color: '#317290' },
  { label: 'パープル', value: 'purple', color: '#664785' },
  { label: 'ピンク', value: 'pink', color: '#F94C97' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'グレー', value: 'gray', color: '#8A8C8C' }
]

export const laceColorObjs = [
  { label: 'グレー', value: 'gray', color: '#8A8C8C' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: '中白ブラック', value: 'materialBlack', color: '#282925' },
  { label: 'ブラック', value: 'black', color: '#282925' },
  { label: '中白レッドオレンジ', value: 'materialRedOrange', color: '#FF362E' },
  { label: 'レッドオレンジ', value: 'redOrange', color: '#FF362E' },
  { label: '中白オレンジ', value: 'materialOrange', color: '#FF6C23' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: '中白ばなな', value: 'materialBanana', color: '#E8C84B' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'むきばなな', value: 'brown', color: '#D7CEA5' },
  { label: '中白ピンク', value: 'materialPink', color: '#f73187' }
]
export const edgeColors = leatherColorObjs

export const stitchColorObjs = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'オレンジ', value: 'orange', color: '#e37d00' },
  { label: 'イエロー', value: 'yellow', color: '#debd00' },
  { label: 'コルク', value: 'cork', color: '#CE7220' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#4EB5DC' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#002bff' },
  { label: 'ホワイト', value: 'white', color: '#eee' },
  { label: 'グリーン', value: 'green', color: '#009c09' },
  { label: 'パープル', value: 'purple', color: '#6a1ca3' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'グレー', value: 'gray', color: '#828282' },
  { label: 'ライムグリーン', value: 'limeGreen', color: '#8BBD85' }
]

export const hamidashiObjs = [
  { label: '切りハミ(ホワイト)', value: 'kirihamiWhite', color: '#fff' },
  { label: '玉ハミ(ブラック)', value: 'black', color: '#1E1E1E' },
  { label: '玉ハミ(ネイビー)', value: 'navy', color: '#363C53' },
  { label: '玉ハミ(チョコレート)', value: 'chocolate', color: '#652821' },
  { label: '玉ハミ(コルク)', value: 'cork', color: '#CE7220' },
  { label: '玉ハミ(レッド)', value: 'red', color: '#CB1527' },
  { label: '玉ハミ(レッドオレンジ)', value: 'redOrange', color: '#FF362E' },
  { label: '玉ハミ(ばなな)', value: 'yellow', color: '#E8C84B' },
  { label: '玉ハミ(レモンイエロー)', value: 'lemonYellow', color: '#D9D943' },
  { label: '玉ハミ(オレンジ)', value: 'orange', color: '#FF6C23' },
  { label: '玉ハミ(ブルー)', value: 'blue', color: '#193B85' },
  { label: '玉ハミ(ベイラーブルー)', value: 'valorBlue', color: '#61BCBA' },
  { label: '玉ハミ(早熟ばなな)', value: 'mardiGras', color: '#4e734c' },
  { label: '玉ハミ(ティール)', value: 'teal', color: '#317290' },
  { label: '玉ハミ(パープル)', value: 'purple', color: '#664785' },
  { label: '玉ハミ(ピンク)', value: 'pink', color: '#F94C97' },
  { label: '玉ハミ(ホワイト)', value: 'white', color: '#fff' },
  { label: '玉ハミ(グレー)', value: 'gray', color: '#8A8C8C' },
  { label: '玉ハミ(むきばなな)', value: 'brown', color: '#D7CEA5' }
]

export const hamidashiOfCatcher = [...hamidashiObjs, { label: 'ハミダシなし(ツマミ)', value: 'none', color: '#fff' }]

const commonPartsObjs = [
  // 共通
  { label: '全体', value: 'all' },
  { label: '捕球面', value: 'catchFace' },
  { label: 'ウェブ', value: 'web' },
  { label: 'ウェブ2', value: 'web2' },
  { label: 'ヘリ革', value: 'edge' },
  { label: '親指掛け紐', value: 'thumbHook' },
  { label: '小指掛け紐', value: 'littleHook' },
  { label: '指カバー/指当て', value: 'indexCover' },
  { label: '平裏', value: 'linings' }
]
const commonPartsNoMoutonObjs = [
  // 共通
  { label: '全体', value: 'all' },
  { label: '捕球面', value: 'catchFace' },
  { label: 'ウェブ', value: 'web' },
  { label: 'ヘリ革', value: 'edge' },
  { label: '親指掛け紐', value: 'thumbHook' },
  { label: '小指掛け紐', value: 'littleHook' },
  { label: '指カバー/指当て', value: 'indexCover' },
  { label: '裏革', value: 'linings' }
]

const firstMittCommonPartsObjs = [
  // 共通
  { label: '全体', value: 'all' },
  { label: '捕球面', value: 'catchFace' },
  { label: 'ウェブ', value: 'web' },
  { label: 'ヘリ革', value: 'edge' },
  { label: '親指掛け紐', value: 'thumbHook' },
  { label: '小指掛け紐', value: 'littleHook' },
  { label: '指カバー/指当て', value: 'indexCover' },
  { label: '裏革', value: 'linings' }
]
const backBeltStyleGloveObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指1', value: 'indexWeb' },
  { label: '人差指2', value: 'indexMiddle' },
  { label: '中指1', value: 'middleIndex' },
  { label: '中指2', value: 'middleRing' },
  { label: '薬指1', value: 'ringMiddle' },
  { label: '薬指2', value: 'ringLittle' },
  { label: '小指1', value: 'littleRing' },
  { label: '小指2', value: 'littleOut' },
  { label: 'バンド', value: 'listBelt' }
]

const backBeltStyleGlove001Objs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指1', value: 'indexWeb' },
  { label: '人差指2', value: 'indexMiddle' },
  { label: '中指1', value: 'middleIndex' },
  { label: '中指2', value: 'middleRing' },
  { label: '薬指1', value: 'ringMiddle' },
  { label: '薬指2', value: 'ringLittle' },
  { label: '小指1', value: 'littleRing' },
  { label: '小指2', value: 'littleOut' }
]

const backBeltStyleGloveHudObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指1', value: 'indexWeb' },
  { label: '人差指2', value: 'indexMiddle' },
  { label: '中指1', value: 'middleIndex' },
  { label: '中指2', value: 'middleRing' },
  { label: '薬指1', value: 'ringMiddle' },
  { label: '薬指2', value: 'ringLittle' },
  { label: '小指1', value: 'littleRing' },
  { label: '小指2', value: 'littleOut' }
  // { label: 'HUD1', value: 'hudLeft' },
  // { label: 'HUD2', value: 'hudRight' }
]
const backBeltStyleGloveBknObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指1', value: 'indexWeb' },
  { label: '人差指2', value: 'indexMiddle' },
  { label: '中指1', value: 'middleIndex' },
  { label: '中指2', value: 'middleRing' },
  { label: '薬指1', value: 'ringMiddle' },
  { label: '薬指2', value: 'ringLittle' },
  { label: '小指1', value: 'littleRing' },
  { label: '小指2', value: 'littleOut' }
  // { label: 'BKN1', value: 'bknLeft' },
  // { label: 'BKN2', value: 'bknRight' }
]

const backCrownBackGloveObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2', value: 'thumbWeb' },
  { label: '人差指1', value: 'indexWeb' },
  { label: '人差指2_中指1', value: 'indexLeftMiddleRight' },
  { label: '中指2_薬指1', value: 'middleLeftRingRight' },
  { label: '薬指2_小指1', value: 'ringLeftLittleRight' },
  { label: '小指2', value: 'littleOut' },
  { label: 'バンド', value: 'listBelt' }
]
const backFirstBackGloveObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2_中指1', value: 'thumbIndexMiddle' },
  { label: '中指2_薬指1', value: 'middleLeftRingRight' },
  { label: '薬指2_小指1', value: 'ringLeftLittleRight' },
  { label: '小指2', value: 'littleOut' },
  { label: 'バンド', value: 'listBelt' }
]

const backGloveForUBackObjs = [
  { label: '親指1', value: 'thumbOut' },
  { label: '親指2・人差指1', value: 'thumbWebAndIndexWeb' },
  { label: '人差指2', value: 'indexMiddle' },
  { label: '中指1', value: 'middleIndex' },
  { label: '中指2', value: 'middleRing' },
  { label: '薬指1', value: 'ringMiddle' },
  { label: '薬指2', value: 'ringLittle' },
  { label: '小指1', value: 'littleRing' },
  { label: '小指2', value: 'littleOut' }
  // { label: 'バンド', value: 'listBelt' }
]
export const catcherMittBackPartsObjs = [
  { label: '親指・人差指・中指1', value: 'thumbIndexMiddleRight' },
  { label: '中指2・薬指・小指', value: 'middleLeftRingLittle' },
  { label: '中指2・薬指', value: 'middleLeftRing' },
  { label: '小指2', value: 'littleOut' },
  { label: '背面台', value: 'fingerStand' }
]

const backOfRegularBackStyleCatcherMittObjs = [
  { label: '親指・人差指・中指1', value: 'thumbIndexMiddleRight' },
  { label: '中指2・薬指', value: 'middleLeftRing' },
  { label: '小指2', value: 'littleOut' },
  { label: '背面台', value: 'fingerStand' },
  { label: 'バンド', value: 'listBelt' }
]
const backOfBeltBackStyleCatcherMittObjs = [
  { label: '親指・人差指・中指1', value: 'thumbIndexMiddleRight' },
  { label: '中指2・薬指・小指', value: 'middleLeftRingLittle' },
  { label: '背面台', value: 'fingerStand' }
]
const backFirstMittObjs = [
  { label: 'バンド', value: 'listBelt' },
  { label: '親指', value: 'thumb' },
  { label: 'ウェブ下', value: 'underWeb' },
  { label: 'ブーメラン', value: 'boomerang' }
]
const backFirstMittNoBeltObjs = [
  { label: '親指', value: 'thumb' },
  { label: 'ウェブ下', value: 'underWeb' },
  { label: 'ブーメラン', value: 'boomerang' }
]

// 捕球面
export const catchFacePartsObjs = [...commonPartsObjs]
export const catcherMittCatchFaceObjs = [...commonPartsObjs, { label: 'ターゲット', value: 'catchFaceTarget' }]

// 背面

export const gloveBeltBackPartsForBomberSeriesObjs = [...commonPartsNoMoutonObjs, ...backBeltStyleGloveObjs]
export const gloveBeltBackPartsObjs = [...commonPartsObjs, ...backBeltStyleGloveObjs]
export const gloveCrownBackPartsObjs = [...commonPartsObjs, ...backCrownBackGloveObjs]
export const gloveFirstBackPartsObjs = [...commonPartsNoMoutonObjs, ...backFirstBackGloveObjs]
export const infielderBackPartsForUBackObjs = [...commonPartsObjs, ...backGloveForUBackObjs]
export const firstMittBackPartsObjs = [...firstMittCommonPartsObjs, ...backFirstMittObjs]
export const firstMittBackPartsNoBeltObjs = [...firstMittCommonPartsObjs, ...backFirstMittNoBeltObjs]
export const catcherMittBackOfBeltBackStylePartsObjs = [...commonPartsObjs, ...backOfBeltBackStyleCatcherMittObjs].filter((p) => p.value !== 'web2')
// 001型用
export const gloveBeltBackPartsForBomber001Objs = [...commonPartsNoMoutonObjs, ...backBeltStyleGlove001Objs]
// HUD型用
export const gloveBeltBackPartsForBomberHudObjs = [...commonPartsNoMoutonObjs, ...backBeltStyleGloveHudObjs]
// BKN型用
export const gloveBeltBackPartsForBomberBknObjs = [...commonPartsNoMoutonObjs, ...backBeltStyleGloveBknObjs]
export const partsObjs = [
  ...commonPartsObjs,
  ...catchFacePartsObjs,
  ...backBeltStyleGloveObjs,
  ...backCrownBackGloveObjs,
  ...backFirstBackGloveObjs,
  ...firstMittBackPartsObjs,
  ...catcherMittCatchFaceObjs,
  ...backOfBeltBackStyleCatcherMittObjs,
  ...backOfRegularBackStyleCatcherMittObjs,
  ...backBeltStyleGlove001Objs,
  ...backBeltStyleGloveHudObjs, // HUD
  ...backBeltStyleGloveBknObjs // BKN
]

export const gorillaLabelObjs = [
  { label: 'ごりら顔(ワッペン)', value: 'headWappen', price: 0, imageUrl: '/gorilla/labels/gorillaFace.jpg' },
  { label: '黄色のばなな(刺繍)', value: 'overAllWappen2', imageUrl: '/gorilla/labels/bananaGorillaLabel.jpg' },
  { label: '金のばなな(ウェルダー)', value: 'superMatureKing', imageUrl: '/gorilla/labels/welderLabel.jpg' }
]
export const gorillaBomberLabelObjs = [
  { label: '黄色のばなな(刺繍)', value: 'overAllWappen2', imageUrl: '/gorilla/labels/bananaGorillaLabel.jpg' },
  { label: '金のばなな(ウェルダー)', value: 'superMatureKing', imageUrl: '/gorilla/labels/welderLabel.jpg' }
]
export const gorillaAllLabelObjs = [...gorillaLabelObjs, ...gorillaBomberLabelObjs]

export const moutonObjs = [
  { label: '白', value: 'white', color: '#fff', imageUrl: '/gorilla/colorSettings/mouton/white.jpg' },
  { label: '黒', value: 'black', color: '#1E1E1E', imageUrl: '/gorilla/colorSettings/mouton/black.jpg' }
]

const dispatchObjects = {
  stitch: stitchColorObjs,
  linings: leatherColorObjs,
  lace: laceColorObjs,
  hamidashi: hamidashiObjs,
  all: leatherColorObjs,
  catchFace: leatherColorObjs,
  web: leatherColorObjs,
  web2: leatherColorObjs,
  edge: leatherColorObjs,
  thumbHook: leatherColorObjs,
  thumbWebAndIndexWeb: leatherColorObjs,
  littleHook: leatherColorObjs,
  indexCover: leatherColorObjs,
  thumbOut: leatherColorObjs,
  thumbWeb: leatherColorObjs,
  thumbIndexMiddle: leatherColorObjs,
  thumbIndexMiddleRight: leatherColorObjs,
  indexWeb: leatherColorObjs,
  indexMiddle: leatherColorObjs,
  middleIndex: leatherColorObjs,
  middleRing: leatherColorObjs,
  middleLeftRing: leatherColorObjs,
  middleLeftRingRight: leatherColorObjs,
  middleLeftRingLittle: leatherColorObjs,
  ringMiddle: leatherColorObjs,
  ringLittle: leatherColorObjs,
  ringLeftLittleRight: leatherColorObjs,
  littleRing: leatherColorObjs,
  littleOut: leatherColorObjs,
  listBelt: leatherColorObjs,
  thumb: leatherColorObjs,
  boomerang: leatherColorObjs,
  underWeb: leatherColorObjs,
  catchFaceTarget: leatherColorObjs,
  indexLeftMiddleRight: leatherColorObjs,
  indexAndMiddle: leatherColorObjs,
  fingerStand: leatherColorObjs
}

export const dispatchForBomberSeriesObjects = {
  ...dispatchObjects,
  gorillaLabel: gorillaBomberLabelObjs
}

export const dispatchForBomberHudObjects = {
  ...dispatchObjects,
  hudLeft: leatherColorObjs,
  hudRight: leatherColorObjs,
  gorillaLabel: gorillaBomberLabelObjs
}

export const dispatchForBomberBknObjects = {
  ...dispatchObjects,
  bknLeft: leatherColorObjs,
  bknRight: leatherColorObjs,
  gorillaLabel: gorillaBomberLabelObjs
}

export const dispatchForNormalSeriesObjects = {
  ...dispatchObjects,
  mouton: moutonObjs,
  gorillaLabel: gorillaLabelObjs
}
export const dispatchForCatcherObjects = {
  ...dispatchForNormalSeriesObjects,
  hamidashi: hamidashiOfCatcher
}

// export const PARTS_BUTTON_OPTION = 'gorilla-parts-button-option'
export const LEATHER_COLOR_BUTTON_OPTION = 'gorilla-leather-color-button-option'
export const LACE_COLOR_BUTTON_OPTION = 'gorilla-lace-color-button-option'
export const EDGE_COLOR_BUTTON_OPTION = 'gorilla-edge-color-button-option'
export const STITCH_COLOR_BUTTON_OPTION = 'gorilla-stitch-color-button-option'
export const HAMIDASHI_COLOR_BUTTON_OPTION = 'gorilla-hamidashi-color-button-option'
export const MOUTON_BUTTON_OPTION = 'gorilla-mouton-button-option'
export const LABEL_BUTTON_OPTION = 'gorilla-label-button-option'
export const DIRECT_EMBROIDERY_LABEL_BUTTON_OPTION = 'gorilla-direct-embroidery-label-button-option'
